import { useRowSelectionContextOptional } from 'components/atoms/RowSelectionContext';
import { ResultsMode } from 'interfaces/experimentResults';
import { useMemo } from 'react';
import { useCurrentLabId } from 'utils/useCurrentLab';
import { useEncodedFilters } from 'utils/useEncodedFilters';
import { buildDatasetScopeCasesParams } from './buildDatasetScopeCasesParams';
import { casesOptions, casesSchema } from './constants';

export const useCasesParams = (differentQueryParams?: {
  filters?: any;
  features?: any;
  clinicalData?: any;
  slidesMode?: boolean;
  resultsMode?: ResultsMode;
}) => {
  const { labId } = useCurrentLabId();
  const rowSelectionContext = useRowSelectionContextOptional();
  const { selectionMode, selectedRows, omittedRows } = rowSelectionContext || {};
  const {
    queryParams: {
      filters,
      features,
      clinicalData,
      searchTerm,
      slidesMode,
      resultsMode,
      caseIdsToInclude: caseIdsToIncludeFilter,
      slideIdsToInclude: slideIdsToIncludeFilter,
    },
  } = useEncodedFilters();

  return useMemo(
    () => ({
      casesParams: buildDatasetScopeCasesParams({
        labId,
        selectionMode,
        selectedRows,
        omittedRows,
        queryParams: {
          filters,
          features,
          clinicalData,
          searchTerm,
          slidesMode,
          resultsMode,
          caseIdsToInclude: caseIdsToIncludeFilter,
          slideIdsToInclude: slideIdsToIncludeFilter,
        },
        overrides: differentQueryParams,
      }),
      schema: casesSchema,
      options: casesOptions,
    }),
    [
      labId,
      filters,
      features,
      clinicalData,
      searchTerm,
      slidesMode,
      resultsMode,
      selectionMode,
      selectedRows,
      omittedRows,
      caseIdsToIncludeFilter,
      slideIdsToIncludeFilter,
      differentQueryParams,
    ]
  );
};
